import React, { Component } from 'react';

class ExamImg extends Component {
    render() {
        return (
            <div className={this.props.originClass === true ? "img-wrap active" : "img-wrap"}>
                <img src="https://images.unsplash.com/photo-1615929380854-c39b4ac2cdb5?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80" alt="" />
                <img src="https://images.unsplash.com/photo-1508739773434-c26b3d09e071?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="" />
            </div>
        );
    }
}

export default ExamImg;